import { useState } from 'react'
import { useLocation as rawUseLocation } from 'react-router-dom'
import FlashType from 'javascripts/layouts/v2/FlashType'

interface FlashState {
  flash: FlashType;
}

const useLocation = () => {
  const location = rawUseLocation()
  const state = (location.state ?? {}) as FlashState

  return {
    ...location,
    flash: state.flash,
  }
}

const useFlash = (initialState: FlashType = null) => {
  const location = useLocation()
  return useState<FlashType>({ ...initialState, ...location.flash })
}

export { useFlash, useLocation }